import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nav"]

  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.handleScroll)
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    if (this.hasNavTarget) {
      if (window.scrollY > 0) {
        this.navTarget.classList.add("bg-opacity-95")
        this.navTarget.classList.add("shadow-lg")
      } else {
        this.navTarget.classList.remove("bg-opacity-95")
        this.navTarget.classList.remove("shadow-lg")
      }
    }
  }

  scrollToSection(event) {
    event.preventDefault()
    const sectionId = event.currentTarget.getAttribute("href")
    const section = document.querySelector(sectionId)
    if (section) {
      section.scrollIntoView({ behavior: "smooth" })
    }
  }
} 